<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav"/>
    <div class="content">
      <div class="headerbg">
        <span>东云启创慕课平台</span>
        <b>DONGYUN QICHUANG MOOC PLATFORM</b>

      </div>
      <div class="mainbody">
        <div class="setionbox">
        <p>东云启创慕课平台是运用最先进的深度教育、系统运筹、云计算和大数据等多种前沿科学技术，将最顶尖的教育产品汇聚一堂，开发建设而成的综合性慕课平台。</p>
      </div>
      <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>课程特点</p>
            <div class="line"></div>
            <div class="text">东云启创慕课平台包含职业技能提升、创新创业教育、核心能力培养、专业知识拓展、职业生涯规划五大类课程，并囊括了海量精品慕课，以满足来自不同层次的不同角色的学习需求。平台采用课程教学、高频特训、深度指导、强化实践和双阶交流的完备学习方法，能够有效帮助学习者进行精准训练，从而极大提高学习效率



</div>
          </div>
          <div class="right"><img  style="width:546px; "src="https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/课程体系 拷贝@2x.png" alt=""></div>
        </div>
      </div>

        <div class="setionbox">
        <div class="setion">

          <div class="right"><img  style="width:550px; "src="https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/学员 拷贝@2x.png" alt=""></div>
          <div class="left">
            <p>人群划分</p>
            <div class="line"></div>
            <div class="text">人群划分为学生、社会物业人员、退休人员、就业困难人群（包含残疾人）、农民工、下岗人员、其他



</div>
          </div>
        </div>
      </div>

       <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>平台优势</p>
            <div class="line"></div>
            <div class="text">实名认证，防止刷课，活体检测，管理系统完善，自动暂停，随机拍照，数据抓取、挖掘、分析，人脸识别





</div>
          </div>
          <div class="right"><img  style="width:458px; "src="https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/组 13 拷贝@2x.png" alt=""></div>
        </div>
      </div>



      </div>
    </div>
    <Footer/>

  </div>
</template>

<script>
export default {
  name: 'DongyunQichuangMOOCPlatform',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  p {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .line {
    margin-top: 20px;
    width: 120px;
    height: 4px;
    background: #f39a21;
  }
  .text {
    width: 468px;
    margin-top: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
     line-height: 1.8;
  }
}
.right {
  flex: 1;
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("~https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/组 38@2x.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
  }
}
.mainbody>.setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1069px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>

    






// WEBPACK FOOTER //
// src/pages/DongyunQichuangMOOCPlatform.vue